import React from 'react';
import {IconProps} from '../interfaces';

export const BookmarkFilledIcon=({size=17, color}:IconProps):JSX.Element=>
	<svg width={size} height={size} viewBox="0 0 14 16" fill={color || 'yellow'} xmlns="http://www.w3.org/2000/svg">
		<path fillRule="evenodd" clipRule="evenodd" d="M3.25 0C2.58696 0 1.95107 0.263392 1.48223 0.732233C1.01339 1.20107 0.75 1.83696 0.75 2.5V14.5C0.75 14.8746 0.959347 15.2178 1.29242 15.3892C1.62549 15.5606 2.02642 15.5315 2.33124 15.3137L7 11.9789L11.6688 15.3137C11.9736 15.5315 12.3745 15.5606 12.7076 15.3892C13.0407 15.2178 13.25 14.8746 13.25 14.5V2.5C13.25 1.83696 12.9866 1.20107 12.5178 0.732233C12.0489 0.263392 11.413 0 10.75 0H3.25Z" />
	</svg>
;
